module.exports = __webpack_public_path__ + "static/media/biteship-gosend.2f116ab8.png";